import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

const Layout = () => {
  return (
    <>
      <Navbar />
      <div className="md:pt-20 pb-24 md:pb-0">
        <Outlet />
      </div>
    </>
  );
};

export default Layout;
